// Merge the given order with the list of all available topics
export const merge = (topicIds, orderedIds) => [
  ...orderedIds.filter(id => topicIds.includes(id)),
  ...topicIds.filter(id => !orderedIds.includes(id)),
];
